<template>
  <el-dialog
    title="抽取"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    @close="close"
  >
    <el-form
      :model="extractionForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      :disabled="isReadOnly"
      :label-width="formLabelWidth"
    >
      <el-form-item label="节点名称" prop="name">
        <el-input v-model="extractionForm.name" show-word-limit maxlength="20">
        </el-input>
      </el-form-item>
      <el-form-item label="抽取方式">
        <div class="lineBox">
          <el-radio-group v-model="extractionForm.extractType">
            <el-radio-button :label="1">按比例抽取</el-radio-button>
            <el-radio-button :label="2" :disabled="fixedNumberExtraction">按固定人数抽取</el-radio-button>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="分组排布">
        <el-form-item
          v-for="(ratio, index) in extractionForm.nodeList"
          :label="index + 1 + '.拆分人群'"
          :key="index"
          :label-width="'100px'"
        >
          <div class="lineBox">
            <el-input
              v-if="extractionForm.extractType === 1"
              style="width:100px;margin: 0 10px 0 0"
              v-model="ratio.percent"
            ></el-input>
            <el-input
              v-if="extractionForm.extractType === 2"
              @input.native="checkputn"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              style="width:100px;margin: 0 10px 0 0"
              v-model="ratio.num"
            ></el-input>
            <span>{{ extractionForm.extractType === 1 ? "%" : "人" }}</span>
            <el-button
              style="margin: 0 0 0 30px"
              v-if="index"
              @click.prevent="removeRatio(index)"
              >删除</el-button
            >
          </div>
        </el-form-item>
      </el-form-item>
      <div class="lineBox" style="margin-left:80px">
        <el-button @click="addRatio">+添加分组</el-button>
        <el-button v-if="extractionForm.extractType === 1" @click="constrain"
          >等比例分配</el-button
        >
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary"  v-loading="loading" :disabled="isReadOnly" @click="extractionSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "extractionDialog",
  data() {
    return {
      fixedNumberExtraction:true,
      loading: false,
      sumArray: 0,
      formLabelWidth: "80px",
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      extractionForm: {
        name: "",
        extractType: 1,
        nodeList: [
          {
            index: 1,
            percent: "0",
            num:""
          },
        ],
      },
    };
  },
  props: {
    // currentLink: null,
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  components: {},
  created() {
    mnode.getNode({ nodeId: this.nodeId }).then((res) => {
      if (res.code === 1 && res.data.name) {
        this.extractionForm.name = res.data.name;
        if (res.data.extractNode) {
          let listData = [];
          this.fixedNumberExtraction = false;
          this.extractionForm.extractType = res.data.extractNode.rule ? res.data.extractNode.rule:1;
          if (res.data && res.data.extractNode && res.data.extractNode.rate && res.data.extractNode.rule==1) {
            listData = res.data.extractNode.rate.split(",") || [];
          }
          if (res.data && res.data.extractNode && res.data.extractNode.num && res.data.extractNode.rule==2) {
            listData = res.data.extractNode.num.split(",") || [];
          }
          var nodeListT = [];
          listData.forEach((item, index) => {
            var temp = {
              index: index,
            };
            if(res.data.extractNode.rule==1){temp.percent=item}else{temp.num=item};
            nodeListT.push(temp);
          });
          if (nodeListT.length > 0) {
            this.extractionForm.nodeList = nodeListT;
          }
        }
      }
    });
  },
  methods: {
    //只能输入正整数
    checkputn(e){
    // //  let filtered = e.target.value.replace(/^(0-)|[^\d]/g, "");
    // //  e.target.value = Number(filtered);
    //   // //下边写用户输入时需要的执行逻辑
    //   // if(this.ruleForm.inputprize!= filtered) {
    //   //     this.ruleForm.inputprize = filtered
    //   // }
    //   // 不能输入0，绑定的值如果小于1，那么输入框置空
    // if (e.target.value == "") {
    //    e.target.value = "";
    //    this.$message.error("输入人数不能超过9999999人");
    // }
    },
    close() {
      this.viewVisible = false;
    },
    //删除
    removeRatio(index) {
      let node = this.extractionForm.nodeList[index];
      this.extractionForm.nodeList.splice(index, 1);
    },
    //添加分组
    addRatio() {
      this.extractionForm.nodeList.push({
        index: this.extractionForm.nodeList.length + 1,
        percent: 0,
        num: "",
      });
    },
    //等比例分配
    constrain() {
      let l = (100 / this.extractionForm.nodeList.length).toFixed(2);
      this.extractionForm.nodeList.forEach((element) => {
        element.percent = l;
      });
    },
    //确定
    extractionSubmit() {
      if (this.loading) {
        return;
      }
      if(this.extractionForm.extractType =='2'){
        let data = JSON.parse(JSON.stringify(this.extractionForm));
         let is = [];
         let every =data.nodeList.every((item,i)=>{
           var reg = /^\s*$/g;
           if(reg.test(item.num)){
              return false;
           }else{
              is.push(i + 1)
              return true;
           }
         })
         if(!every){
           this.$message.error(`输入框人群数量不能为空!`)
           return false
      }}
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify();
          this.loading = true;
          mnode.updateDetailextract(data).then((res) => {
             this.loading = false;
            if (res.code === 1) {
              this.viewVisible = false;
              this.$emit("change", {});
              this.$emit("change-name", data);
            }else{
               this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });  
    },
    getDataify() {
      let formData = {
        name: "",
        nodeId: "",
      };
      let data = JSON.parse(JSON.stringify(this.extractionForm));
      if (this.extractionForm.extractType == "1") {
        // let sum = 0;
        // data.nodeList.forEach((item) => {
        //   sum += Number(item.percent);
        // });
        // this.sumArray = parseFloat(sum);
        let sum = data.nodeList.reduce((a, b) => {
          return parseFloat(a.percent) + parseFloat(b.percent)
        }, 0)
        if (sum.toFixed(2) > 100) {
          this.$message.error("分组排布累加比例时不能超过100%！");
          return false;
        }
      }
      let rateData = [];
      let numData=[];
      data.nodeList.forEach((item, index) => {
        return rateData.push(item.percent);
      });
      data.nodeList.forEach((item,index)=>{
         return numData.push(item.num);
      })
      if(this.extractionForm.extractType===1){
         formData.rate = rateData.join(",");
      }
      if(this.extractionForm.extractType===2){
           formData.num = numData.join(",");
      }//按比例调整
      formData.rule = this.extractionForm.extractType;
      formData.nodeId = this.$props.nodeId;
      formData.name = this.extractionForm.name;
      // formData.sourceNodeId = this.currentLink
      // formData.extractNode = JSON.parse(
      //   JSON.stringify(data, (k, v) => {
      //     return k === "name"
      //       ? undefined
      //       : typeof v === "string" && k !== "percent"
      //       ? parseFloat(v)
      //       : v;
      //   })
      // );
      return formData;
    },
  },
};
</script>

<style></style>
